import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../Common/data.service';
import { AppTokenHandler } from '../../Common/app-token-handler';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AzureADAuthService } from 'src/app/Common/azure-adauth.service';
import { LoginService } from 'src/app/Common/login.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
    referralURL: string;
    private azure_token: string = '';
    private _destroying$ = new Subject<void>();
    constructor(private appToken: AppTokenHandler, private gservice: DataService,
        private route: Router,
        // private spinnerService: Ng4LoadingSpinnerService,
        private authADService: AzureADAuthService,
        private loginService: LoginService,
    ) { }
    ngOnDestroy(): void {
        this._destroying$.next();
        this._destroying$.complete();
    }


    ngOnInit() {
        if (environment.IsHostingEnvAzure) {
            this.acquireAzureToken();
        }
        else {
            this.GetUserDetails();
        }

    }


    GetUserDetails() {
        this.appToken.clearSessionToken();
        if (this.appToken.getSessionToken().length <= 0) {
            // this.spinnerService.show();
            this.gservice.Login('', this.azure_token).subscribe((data: any) => {
                if (data.IsAuthenticated) {
                    this.appToken.setSessionToken(data);
                    // this.route.navigate(['/home']);
                    this.route.navigate(['/dashboard']);
                } else {
                    this.route.navigate(['/error/1']);
                }
            }, (error: Response) => {
                if (error.status <= 0) {
                    this.route.navigate(['/error/2']);
                } else if (error.status === 401) {
                    this.route.navigate(['/error/1']);
                } else {
                    this.route.navigate(['/error/2']);
                }
            }, () => {
                // this.spinnerService.hide();
            });
        } else {
            // this.route.navigate(['/home']);
            this.route.navigate(['/dashboard']);
        }
    }
    async acquireAzureToken() {
        this.authADService.handleQueryParameters()
            .pipe(
                takeUntil(this._destroying$),
                catchError(error => {
                    return throwError(() => error);
                })
            )
            .subscribe({
                next: (result) => {
                    if (result) {
                        this.azure_token = result;
                        this.loginService.GetUserDetails(this.azure_token);
                    }
                }
            });
    }

}
